import { useEffect, useMemo, useState } from 'react'
import styles from './App.module.scss'
import { ConnectionsGraph, MoodId, MOODS } from './components/ConnectionsGraph/ConnectionsGraph'
import { Header } from './components/Header/Header'
import { Footer } from './components/Footer/Footer'
import { User } from './types/User'
import { randomNumberFromInterval } from './utils/math-utils'



const NUMBER_OF_BUBBLES = 64

function App() {
  const [filterBy, setFilterBy] = useState<MoodId | null>(null)
  const [users, setUsers] = useState<User[] | null>(null)
  const [showFilterList, setShowFilterList] = useState(false)

  const filteredUsers = useMemo(() => {
    if (!users) return null
    const getUsersFrom = 0
    const getUsersTo = randomNumberFromInterval(55, 65)

    const arrCopy = users.slice(0)

    shuffleArray(arrCopy)

    return arrCopy.filter((x, i) => {
      return i >= getUsersFrom && i <= getUsersTo
    })
  }, [users, filterBy])
  useEffect(() => {
    fetch('/data/users.json')
      .then((response) => response.json())
      .then((data: User[]) => {
        setUsers(data)
      })
  }, [])

  function handleFilterClick() {
    setShowFilterList(true)
  }

  return (
    <div className={styles.app}>
      {/* <Header filterBy={filterBy} onButtonClick={handleFilterClick} /> */}
      <div className={styles.content}>
        {showFilterList ? (
          <FilterList
            filterBy={filterBy}
            onSelect={(filter) => {
              setFilterBy(filter)
              setShowFilterList(false)
            }}
          />
        ) : filteredUsers ? (
          <ConnectionsGraph
            filterBy={filterBy}
            onButtonClick={handleFilterClick}
            data={filteredUsers}
          />
        ) : (
          <div className={styles.loader}>Loading</div>
        )}
      </div>
      <Footer />
    </div>
  )
}

type FilterListProps = {
  filterBy: MoodId | null
  onSelect: (item: MoodId | null) => void
}

function FilterList(props: FilterListProps) {
  return (
    <div className={styles.filterList}>
      <div className={styles.filterListItem} onClick={() => props.onSelect(null)}>
        Show All
      </div>
      {MOODS.map((mood) => {
        return (
          <div key={mood.mood} className={styles.filterListItem} onClick={() => props.onSelect(mood.mood)}>
            {mood.mood}
          </div>
        )
      })}
    </div>
  )
}

/* Randomize array in-place using Durstenfeld shuffle algorithm */
function shuffleArray(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
  }
}


export default App
